<script setup lang="ts">
import { ArrowLeft } from '@lucide/vue'
import { useRouter } from 'vue-router'

withDefaults(
  defineProps<{
    description?: string
    eyebrow?: string
    prominent?: boolean
    title: string
  }>(),
  {
    eyebrow: 'routecamp',
    prominent: false,
  },
)

const router = useRouter()

const goBack = () => {
  const historyState = window.history.state as { back?: string | null } | null
  if (historyState?.back) {
    router.back()
  } else {
    void router.push({ name: 'workspaces' })
  }
}
</script>

<template>
  <nav class="px-5 pt-4 sm:px-8">
    <div class="mx-auto max-w-5xl">
      <button
        type="button"
        class="-ml-2.5 inline-flex min-h-11 items-center gap-1.5 rounded-lg px-2.5 py-1.5 font-mono text-[13px] font-medium text-stone-600 transition-colors hover:bg-stone-100 hover:text-stone-900"
        aria-label="Go back"
        @click="goBack"
      >
        <ArrowLeft class="h-4 w-4" />
        Back
      </button>
    </div>
  </nav>

  <section class="border-b border-stone-200/70 px-5 pb-8 pt-5 sm:px-8 sm:pb-10 sm:pt-6">
    <div class="mx-auto flex max-w-5xl flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
      <div class="min-w-0">
        <span class="mb-3 block font-mono text-[11px] uppercase tracking-widest text-stone-500">
          {{ eyebrow }}
        </span>
        <h1
          :class="[
            'max-w-4xl font-mono text-3xl font-semibold leading-tight text-stone-900 sm:text-4xl',
            prominent && 'lg:text-5xl',
          ]"
        >
          {{ title }}
        </h1>
        <p v-if="description" class="mt-3 max-w-2xl text-sm leading-relaxed text-stone-600">
          {{ description }}
        </p>
      </div>

      <div v-if="$slots.actions" class="flex shrink-0 flex-wrap gap-2">
        <slot name="actions" />
      </div>
    </div>
  </section>
</template>
